/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EntrustSignatureRequestDto } from '../../models/entrust-signature-request-dto';
import { EntrustSignatureStartResponseDto } from '../../models/entrust-signature-start-response-dto';

export interface RequestSignature$Params {
  processId: string;
      body: EntrustSignatureRequestDto
}

export function requestSignature(http: HttpClient, rootUrl: string, params: RequestSignature$Params, context?: HttpContext): Observable<StrictHttpResponse<EntrustSignatureStartResponseDto>> {
  const rb = new RequestBuilder(rootUrl, requestSignature.PATH, 'post');
  if (params) {
    rb.path('processId', params.processId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EntrustSignatureStartResponseDto>;
    })
  );
}

requestSignature.PATH = '/kyc/processes/{processId}/signature';
